import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = ({ color = designSystem.colors.neutral600, ...props }) => (
    <Svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <Path d="M12.037 4.46094L4.96592 11.532" stroke={color} strokeWidth={2} strokeLinecap="round" />
        <Path d="M4.9668 4.46875L12.0379 11.5398" stroke={color} strokeWidth={2} strokeLinecap="round" />
    </Svg>
);

export default SvgComponent;
